import { MaskLines, Reveal } from "../components/anim";
import { Eyebrow } from "../components/ui-bits";
import useSEO from "../hooks/useSEO";

const SECTIONS = [
  {
    title: "Chi siamo",
    body: [
      "Sprizziamoci — L'aperitivo on the road: servizio itinerante di cocktail e bevande alla spina per eventi.",
      "[Dati societari e titolare del trattamento: da inserire quando disponibili.] Recapito: +39 340 384 5845.",
    ],
  },
  {
    title: "Quali dati raccogliamo",
    body: [
      "Dai moduli raccogliamo solo ciò che inserisci volontariamente (nome, email, telefono, dettagli evento o attività): usati esclusivamente per risponderti.",
    ],
  },
  {
    title: "Conservazione e diritti",
    body: [
      "Dati conservati per il tempo necessario a gestire il contatto, mai ceduti a terzi. Accesso, rettifica e cancellazione: scrivici ai recapiti indicati.",
    ],
  },
  {
    title: "Cookie",
    body: [
      "Solo cookie tecnici per le preferenze del sito. Nessun tracciamento di terze parti al momento.",
      "Google Analytics o strumenti equivalenti solo se attivati in futuro, previa configurazione e consenso.",
    ],
  },
];

export default function Privacy() {
  useSEO(
    "Privacy e cookie | Sprizziamoci",
    "Informativa su privacy e cookie del sito Sprizziamoci — L'aperitivo on the road: quali dati raccogliamo, come li usiamo e quali diritti hai."
  );
  return (
    <article data-testid="privacy-page">
      <section className="pt-32 md:pt-44 pb-14">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <Eyebrow>Note legali</Eyebrow>
          <MaskLines
            lines={["PRIVACY", "E COOKIE."]}
            as="h1"
            when="load"
            delay={0.15}
            lineClass="font-display font-semibold tracking-tight leading-[1] text-[clamp(2.6rem,6.5vw,5.5rem)]"
            className="mt-6"
          />
        </div>
      </section>
      <section className="pb-24 md:pb-32">
        <div className="mx-auto max-w-3xl px-5 md:px-8 space-y-12">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div className="border-t border-white/[0.08] pt-8">
                <h2 className="font-display text-2xl md:text-3xl font-semibold mb-4">{s.title}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="text-sm md:text-base leading-relaxed text-white/60 mb-3">
                    {p}
                  </p>
                ))}
              </div>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-xs leading-relaxed text-white/40 border-t border-white/[0.08] pt-8">
              Questo documento è un riassunto di massima, redatto senza inventare dati societari:
              l'informativa estesa ai sensi del Regolamento UE 2016/679 sarà resa disponibile
              insieme ai dati identificativi del titolare.
            </p>
          </Reveal>
        </div>
      </section>
    </article>
  );
}
